module.exports = __webpack_public_path__ + "img/Shiba-BG.4a95c461.jpg";